import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';

const ANIMATION_TIME = 300;

type SlideProps = {
  children: string;
};

export function Slide({ children }: SlideProps) {
  const valueRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const { current: valueElement } = valueRef;

    if (!valueElement) {
      return;
    }

    if (!valueElement.textContent) {
      valueElement.textContent = children;
      return;
    }

    valueElement.classList.add('slide');

    const handler = ({ animationName }: AnimationEvent) => {
      if (!valueElement) {
        return;
      }

      if (animationName === 'slide') {
        valueElement.textContent = children;

        valueElement.classList.remove('slide');
        valueElement.classList.add('slide-from-top');
      }

      if (animationName === 'slide-from-top') {
        valueElement.classList.remove('slide-from-top');
      }
    };

    valueElement.addEventListener('animationend', handler);

    return () => {
      if (!valueElement) {
        return;
      }

      valueElement.removeEventListener('animationend', handler);
    };
  }, [children]);

  return <Value ref={valueRef} />;
}

const Value = styled.span.attrs({
  className: createReadableClass({ component: 'slide', element: 'value' })
})`
  display: block;

  &.slide {
    animation: slide ${Math.round(ANIMATION_TIME / 2)}ms ease;
  }

  &.slide-from-top {
    animation: slide-from-top ${Math.round(ANIMATION_TIME / 2)}ms ease;
  }

  @keyframes slide {
    from {
      transform: translateY(0%);
    }

    to {
      transform: translateY(100%);
    }
  }

  @keyframes slide-from-top {
    from {
      transform: translateY(-100%);
    }

    to {
      transform: translateY(0%);
    }
  }
`;
